/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2FyaWFkbmFlcmNpbGxhbW9udHNlcnJhdC9EZXNrdG9wL0ZFSU5BL3BvcnRmb2xpby9wb3J0Zm9saW9fYXJpL3NyYy9hcHAvcHVudG95c2VndWlkby1iYWNrZW5kL3B1bnRveXNlZ3VpZG8tYmFja2VuZC5jb21wb25lbnQuc2Fzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9hcmlhZG5hZXJjaWxsYW1vbnRzZXJyYXQvRGVza3RvcC9GRUlOQS9wb3J0Zm9saW8vcG9ydGZvbGlvX2FyaS9zcmMvYXBwL3B1bnRveXNlZ3VpZG8tYmFja2VuZC9wdW50b3lzZWd1aWRvLWJhY2tlbmQuY29tcG9uZW50LnNhc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/puntoyseguido-backend/puntoyseguido-backend.component.sass.shim.ngstyle.ts